/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S1_HeadingInputs */

const tr_kullanim_s1_heading = /** @type {(inputs: Kullanim_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Taraflar`)
};

const en_kullanim_s1_heading = /** @type {(inputs: Kullanim_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Parties`)
};

const de_kullanim_s1_heading = /** @type {(inputs: Kullanim_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Vertragsparteien`)
};

const ru_kullanim_s1_heading = /** @type {(inputs: Kullanim_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Стороны`)
};

/**
* | output |
* | --- |
* | "1. Parties" |
*
* @param {Kullanim_S1_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s1_heading = /** @type {((inputs?: Kullanim_S1_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S1_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s1_heading(inputs)
	if (locale === "de") return de_kullanim_s1_heading(inputs)
	if (locale === "ru") return ru_kullanim_s1_heading(inputs)
	return tr_kullanim_s1_heading(inputs)
});